import { SiteSurvey } from "api/types/siteSurvey";
import { Photo } from "api/types/photo";
import { PhotoType } from "api/types/photoType";

export interface GetMatchingPhotoReturnType {
  photo: Photo;
  index: number;
}
export function getMatchingPhoto(
  photos: SiteSurvey["photos"],
  photoType: PhotoType
): GetMatchingPhotoReturnType | undefined {
  for (let index = 0; index < photos.length; index++) {
    const photo = photos[index];
    if (photo.typeId === photoType.id) {
      return { index: index, photo: photo };
    }
  }

  return undefined;
}
